import React, { useEffect} from "react";
import { Row, Form } from "react-bootstrap";

import { useGlobalState } from '../../components/globalStateProvider.js';
import { machineListSelectedGlassTimeCustomerAPI } from '../../api/api_definitions.js';


const GlassTimeMachineFamilyListCustomer = () => {

    const {machineFamilyGlassTimeCustomer, setMachineFamilyGlassTimeCustomer, 
           setListCustomerGlassTimeCustomer, setCustomerNameGlassTimeCustomer 
      } = useGlobalState();

    // Reset the info
    useEffect(() => {

      setCustomerNameGlassTimeCustomer("");
    }, [machineFamilyGlassTimeCustomer]);
 
    // API GATEWAY RESPONSE MANAGEMENT --> Return list of machines according to their type
    useEffect(() => {
      let isMounted = true;
      machineListSelectedGlassTimeCustomerAPI(machineFamilyGlassTimeCustomer)
      .then((dataAPI) => {
          if (isMounted) {
          if (dataAPI !== null) {
            setListCustomerGlassTimeCustomer(dataAPI.ListMachines)        
            }
          }
      })
      .catch((error) => {
        console.log(error);
      });
      return () => {
        isMounted = false;
      };
    }, [machineFamilyGlassTimeCustomer, setListCustomerGlassTimeCustomer])

    // Return layout
    return (
      <>
        <Row>
          <Form.Select
            aria-label="Default select example"
            as="select"
            value={machineFamilyGlassTimeCustomer}
            onChange={e => {
              if (e.target.value !== '0') {
                setMachineFamilyGlassTimeCustomer(e.target.value);
              }
            }}>
            <option value="0" disabled>Seleziona la famiglia macchina</option>
            <option value="1">Laser Genius +</option>
            <option value="4">Platino Linear</option>

          </Form.Select>
        </Row>
      </>  
    );
};

export default GlassTimeMachineFamilyListCustomer;